import { newToolFilterOAuthMcp } from "../oauth.ts";

export const granolaMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.granola.ai/favicon/favicon.svg",
  url: "https://mcp.granola.ai/mcp",
  label: "Granola",
});
